import InputMoney from './InputMoney';
export default InputMoney;
